import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { adminAPI } from '../services/api';

const CustomerFooter = () => {
  const { data: appVersion } = useQuery(
    'appVersion',
    () => adminAPI.getAppVersion(),
    {
      staleTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false
    }
  );
  const version = appVersion?.version || process.env.REACT_APP_APP_VERSION || 'dev';

  return (
    <footer className="border-t border-gray-200 bg-white text-gray-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col gap-2 text-sm sm:flex-row sm:items-center sm:justify-between">
          <span>&copy; {new Date().getFullYear()} <a href="https://www.datavisual.ca" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition-colors">DataVisual Marketing Inc.</a> All rights reserved.</span>
          <div className="flex flex-wrap gap-x-5 gap-y-1">
            <Link to="/customer/change-log" className="hover:text-gray-900 transition-colors">Version {version}</Link>
            <Link to="/customer/feedback" className="hover:text-gray-900 transition-colors">Report a Bug or Provide Feedback</Link>
            <Link to="/privacy" className="hover:text-gray-900 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gray-900 transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CustomerFooter;
